<!--人员管理 角色管理 角色管理-->
<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:20px"
        :model="searchForm" ref="searchForm">
        <el-form-item label="名称：">
          <el-input size="medium" placeholder="名称" v-model="searchForm.ROLE_NAME" clearable @keyup.enter.native="handleSearch()">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" id="search" type="primary" @click="handleSearch()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="matchFun()" style="margin-bottom:10px">新增匹配</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="ROLE_NAME" label="角色"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-close" @click="stopFun(scope.row)"
                style="color: rgb(245, 108, 108)">解除匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block" style="float: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import { stopMatch, queryRole } from '@/assets/api/accountManage';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10047', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1004701: 0, 1004702: 0 },
      person_name: sessionStorage.getItem('person_name'),
      client_list: [
        {
          ID: 1,
          name: '用户端',
        },
        {
          ID: 2,
          name: '供应商端',
        },
      ],
      loading: false,
      tableData: [{}],
      searchForm: {},
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryData();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 匹配角色
    matchFun() {
      this.$router.push({ path: '/matchRole/detail' });
    },
    // 解除匹配
    stopFun(row) {
      this.$confirm('确定解除匹配吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          RELEATION_ID: row.ID,
        };
        stopMatch(params)
          .then((result) => {
            this.$message.show({ text: '解除成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消解除' });
      });
    },
    // 拉取
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SYSTEM_USER_ID: Number(sessionStorage.getItem('SYSTEM_USER_ID')),
      };
      if (this.searchForm.ROLE_NAME) {
        params.ROLE_NAME = this.searchForm.ROLE_NAME;
      }
      queryRole(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/operationCenter/queryRole.vue